import {action, makeAutoObservable, observable, runInAction} from 'mobx';
import {DashboardSlotBacklight} from '../DashboardSlotBacklight';
import {define, FREE_MINER_BACKLIGHT} from '../persistence';
import {ConnectedClient} from '../ContextClient';
import {FreeMinerState} from './FreeMinerState';

export default class FreeMinerStateImpl implements FreeMinerState {
  @observable private _isFreeMinerModalVisible = false;
  @observable private _isFreeMinerModalWasVisible = false;
  @observable private _canShowFreeMinerModal = false;
  @observable private _canShowFreeMinerBacklight = false;
  @observable private _isLoading = false;

  constructor(
    private readonly _root: {
      readonly dashboardSlotBacklight: DashboardSlotBacklight;
      readonly connectedClient: ConnectedClient;
    },
  ) {
    makeAutoObservable(this);
  }

  get isFreeMinerModalVisible() {
    return this._isFreeMinerModalVisible;
  }

  get isFreeMinerModalWasVisible() {
    return this._isFreeMinerModalWasVisible;
  }

  get canShowFreeMinerBacklight() {
    return this._canShowFreeMinerBacklight;
  }

  get canShowFreeMinerModal() {
    return this._canShowFreeMinerModal;
  }

  get isLoading() {
    return this._isLoading;
  }

  setCanShowFreeMinerModal = action((val: boolean) => {
    this._canShowFreeMinerModal = val;
  });
  setCanShowFreeMinerBacklight = action((val: boolean) => {
    this._canShowFreeMinerBacklight = val;
  });

  showSlotBacklight = action(() => {
    this._root.dashboardSlotBacklight.show();
  });
  closeSlotBacklight = action(() => {
    this._canShowFreeMinerBacklight = false;
    this._root.dashboardSlotBacklight.close();
    // noinspection JSIgnoredPromiseFromCall
    setRecord({shown: true});
  });
  setWasShownFreeMinerBacklight = action(() => {
    // noinspection JSIgnoredPromiseFromCall
    setRecord({shown: true});
    this._isFreeMinerModalWasVisible = true;
  });
  setFreeMinerModalVisible = action((val: boolean) => {
    this._isFreeMinerModalVisible = val;
  });

  async hasBacklightBeenShown() {
    return getRecord().then(
      (result) => (result.success && result.right?.shown) || false,
    );
  }

  closeFreeMinerModal = async () => {
    runInAction(() => {
      this._isLoading = true;
    });
    await this._root.connectedClient.call('get_promo_pool_miner');

    runInAction(() => {
      this._isLoading = false;
      this._isFreeMinerModalVisible = false;
      this._canShowFreeMinerBacklight = true;
      this._isFreeMinerModalWasVisible = true;
    });
  };
}

export type FreeMinerBacklightRecord = {
  shown: boolean;
};

const [getRecord, setRecord] =
  define<FreeMinerBacklightRecord>(FREE_MINER_BACKLIGHT);
